module.exports = __webpack_public_path__ + "nc_static/media/file_jpg.932ddbae.svg";